import React, { useState, useEffect } from 'react';
import { TextField, CircularProgress, Box, Button, Grid } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

export const AutocompleteWithPaging = ({ fetchSuggestions, model, setModel, inputValue, setInputValue, suggestions, setSuggestions, label, loading, setLoading }) => {
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    useEffect(() => {
        if (model) {
            setLoading(true);
            fetchSuggestions(model)
                .then(data => {
                    setSuggestions(data?.items ?? []);
                    setTotalPages(Math.ceil(data?.numberOfItems / model.numberPerPage));
                    if (data?.items.length === 1) {
                        setInputValue(data?.items[0])
                    }
                    else {
                        setInputValue("")
                    }
                    setLoading(false);
            });
        }
    }, [page, model]); // eslint-disable-line react-hooks/exhaustive-deps

    const handlePageChange = (newPage) => {
        setModel(
            {
                ...model,
                pageNumber: newPage
            }
        )
        setPage(newPage)
    };

    return (
        <Grid container item xs={3} style={{ display: "flex" }}>
            <Autocomplete
                value={inputValue || null}
                onChange={(e, d) => {
                    setInputValue(d);
                }}
                getOptionSelected={(o, v) => o.id === v.id}
                options={suggestions}
                style={{ width: "100%", paddingRight: "10px" }}
                getOptionLabel={(option) => `${option?.customer?.fullName}: ${option?.accountNumber}`}
                renderOption={(option, { selected }) => (
                    <div style={{ width: "100%", textAlign:"center" }}>{`${option?.customer?.fullName}: ${option?.accountNumber}`}</div>
                )}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={label}
                        variant="outlined"
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                            <>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                            ),
                        }}
                    />
                )}
            />
            <Box style={{ display: "flex", width: "100%" }}>
                <Button style={{ marginRight: "auto" }} disabled={page === 1} onClick={() => handlePageChange(page - 1)}>Previous</Button>
                <Button style={{ marginLeft: "auto" }} disabled={page === totalPages} onClick={() => handlePageChange(page + 1)}>Next</Button>
            </Box>
        </Grid>
    );
};
